﻿export default class Psd2details {
    constructor() {
        this.dom = {
            $: window.$,
            $toggleDelay: $('.form-row[data-toggle-delay]'),
            $nextStatus: $('[data-next-status]')
        };
        this.init();
    }
    init() {
        if ($('input[data-validator-id="has-bank"]').length > 0) this.checkBank();
        this.LoadBanks();
        if ($('.bank-dropdown option').length == 1) $('.sub-header-multi-account').hide(); else $('.sub-header-single-account').hide();
        if ($('[data-validator-id="bank-dropdown"]').length > 0) this.AssignBankName();
        if (this.dom.$toggleDelay.length > 0) this.toggleDelay();
        if (this.dom.$nextStatus.length > 0) this.checkPSD2status(this.dom.$nextStatus.first());
        if ($('.verify-popup').length > 0) this.setupVerifyPopup();
        this.AppValiditySubmit();
    }

    checkBank() {
        $('input[data-validator-id="has-bank"]').eq(0).closest('.form-input-group').find('.checkbox-choosed a').on('click', (e) => {
            if ($('[data-validator-id="has-bank"]:checked').val() == '1') {
                $('.time-at-bank, .supported-bank').show();
            }
            if ($('[data-validator-id="has-bank"]:checked').val() == '2') {
                $('.time-at-bank, .supported-bank').hide();
            }
        });
        if ($('input[data-validator-id="has-bank"]:checked').length > 0) $('input[data-validator-id="has-bank"]:checked').closest('.form-input-group').find('a.active').trigger('click');
    }

    checkPSD2status($thisStatus) {
        let that = this;
        let thisDom = this.dom;
        let waitTime = $thisStatus.data('wait-time');
        let refreshId = setInterval(function () {
            thisDom.$nextStatus = $($thisStatus.data('next-status'));
            if (thisDom.$nextStatus.length > 0) {
                $thisStatus.hide();
                thisDom.$nextStatus.show();
                clearInterval(refreshId);
                that.checkPSD2status(thisDom.$nextStatus);
            }
            clearInterval(refreshId);
        }, waitTime);
    }

    toggleDelay() {
        this.dom.$toggleDelay.each((itemId, itemObj) => {
            let delayTime = $(itemObj).data('toggle-delay');
            let refreshId = setInterval(function () {
                $(itemObj).toggle();
                clearInterval(refreshId);
            }, delayTime);
        });
    }

    LoadBanks() {
        if ($('.imglist').length) {
            let url1 = "/api/sitecore/PSD2/GetBankList";
            $.ajax({
                url: url1,
                type: 'post',
                data: '',
                contentType: 'application/json; charset=utf-8',
                cache: false,
                async: true,
                success: function (result) {
                    var data = result.Data;
                    var html = [];
                    jQuery(data).each(function (i, item) {
                        html.push('<img class=col-8 src=' + item + ' />');
                    })
                    $('.imglist').append(html.join(''));
                },
                complete: function (data) {
                }
            });
        }
    }

    AssignBankName() {
        $('[data-validator-id="bank-dropdown"]').on('select2:select', (e) => {
            var option = $('[data-validator-id="bank-dropdown"] option:selected').attr('data-field-decription');
            $('.input-field-description').text(option);
            $('[data-validator-id="bank-number"]').val($('[data-validator-id="bank-dropdown"] option:selected').val());
        });
        var option = $('[data-validator-id="bank-dropdown"] option:selected').attr('data-field-decription');
        $('.input-field-description').text(option);
        $('[data-validator-id="bank-number"]').val($('[data-validator-id="bank-dropdown"] option:selected').val());
    }

    setupVerifyPopup() {
        var popupDelayId;
        var popupDispayed = true;
        var popupDelayTime = $('.verify-popup').data('verify-timer') || '30000';
        var ApplicationValidityDays = $('.applicationvaliditydays').val();        
        var $popupData = $('#popup-data');
        var now = new Date();

        if (!$('.appvalidityconsentname').val() == 1 && ApplicationValidityDays > -1) {
            popupDispayed = false;
            $('#days-left').text(ApplicationValidityDays);
            if (ApplicationValidityDays == 1)
                $('#days-left-text').text('dzień');
        }

        if ($popupData.length > 0 && $popupData.data('value').length != '') {
            $('#' + $popupData.data('placeholder-id')).text(parseInt($popupData.data('value')));
        }

        timerPopup();
        //display popup when mouse leaves window
        $("html").on('mouseleave', function (e) {
            if (!popupDispayed) {
                showPopup();
            }
        });
        //Reset the popup timer if user clicks or moves mouse
        $("html").on('mousemove', function (e) {
            timerPopup();
        });
        $("html").on('keypress', function (e) {
            timerPopup();
        });
        function timerPopup() {
            clearInterval(popupDelayId);
            if (!popupDispayed) {
                popupDelayId = setInterval(function () {
                    showPopup();
                }, popupDelayTime);
            }
        }
        function showPopup() {
            if (!$('.verify-popup').is(':visible')) {
                $('.verify-popup').addClass('visible');
                popupDispayed = true;
            }
        }
        
    }
    AppValiditySubmit() {
        $('.saveappvalidityconsent').on('click', (e) => {
            $(".loading-screen").show();
            var that = this;
            var apphiddenconsentname = $('.appvalidityconsentname').data('validator-id');
            let url1 = "/api/sitecore/Forms/SaveConsent";
            var model = {
                ConsentName: apphiddenconsentname,
                ConsentValue: 1
            };
            getAjaxData("/api/sitecore/Forms/SaveConsent", "POST", false, model, function (data) {
                if (data) {
                    if (data.IsSuccess) {
                        return true;
                    }
                }
            });
            $(".loading-screen").hide();
        });


    }
}

document.addEventListener('DOMContentLoaded', () => new Psd2details());